import React, {useContext} from "react";
import {CSSTransition} from "react-transition-group";
import { AlertContext } from "../Context/alert/alertContext";


export const Alert = () => {
    const {alert, hide} = useContext(AlertContext)

    return (
        <CSSTransition
        in={alert.visible}
        timeout={{
            enter: 500,
            exit: 350
        }}
        classNames={'alert'}
        mountOnEnter
        unmountOnExit
        >
            <div className={`alert alert-${alert.type || 'warning'} alert-dismissible fade show `}>
                <strong>Внимание!</strong>
                &nbsp;{alert.text}
                
                &nbsp;&nbsp;
                <button onClick={hide} type="button" className="btn btn-outline-danger btn-sm" data-dismiss="alert" aria-label="close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </CSSTransition>
    )
}